<ng-container [ngTemplateOutlet]="viewTemplate()!" />

<ng-template #config>
  <rt-dialog-header [heading]="'tl.dashboard.start_trial_dialog.title' | translate" />
  <rt-dialog-body variant="white">
    <div layout layout-vertical [style.width.%]="100">
      @if (showInvolvements()) {
        <section layout layout-vertical>
          <tla-start-free-trial-dialog-chips-lib
            [control]="form.controls['involvement']"
            [elements]="involvements"
          />
        </section>
      }
      <section layout layout-vertical>
        <tla-start-free-trial-dialog-sample-data-lib [control]="form.controls['sampleData']" />
        <span [innerHTML]="legalTerms()" margin-top-small-x margin-lr-small-x></span>
      </section>
    </div>
  </rt-dialog-body>
  <rt-dialog-footer>
    <rt-button variant="plain" (click)="dialogRef.close()">{{
      'tl.common.cancel' | translate
    }}</rt-button>
    <rt-button [disabled]="form.invalid" (click)="startTrial()" variant="primary">
      {{ 'tl.dashboard.start_trial_dialog.buttons.activate_free_trial' | translate }}
    </rt-button>
  </rt-dialog-footer>
</ng-template>

<ng-template #pending>
  <rt-dialog-header [heading]="'tl.dashboard.start_trial_dialog.title' | translate" />
  <rt-dialog-body variant="white">
    <rt-spinner />
  </rt-dialog-body>
  <rt-dialog-footer>
    <rt-button [disabled]="true" variant="plain">{{ 'tl.common.cancel' | translate }}</rt-button>
    <rt-button [disabled]="true" variant="primary">
      {{ 'tl.dashboard.start_trial_dialog.buttons.activate_free_trial' | translate }}
    </rt-button>
  </rt-dialog-footer>
</ng-template>

<ng-template #success>
  <rt-dialog-body variant="white" class="success-template">
    <tla-start-free-trial-dialog-success-lib [texts]="successTexts()" [brand]="brand()" />
  </rt-dialog-body>
  <rt-dialog-footer [hasOptionalActions]="true">
    <rt-button class="optional" variant="plain" (click)="dialogRef.close()">
      <rt-icon prefix name="chevron-left" />
      {{ 'tl.dashboard.start_trial_dialog.buttons.back_to_home' | translate }}</rt-button
    >
    <rt-button variant="primary" (click)="explore()">{{ successTexts().button }}</rt-button>
  </rt-dialog-footer>
</ng-template>
